module.exports = __webpack_public_path__ + "static/media/rentBySqFoot-houses.f0f6695b.png";